import {
  AssistantConversationSection,
  AssistantFeatureWalkthrough,
  AssistantWalkthroughSection,
} from "..";
import { AssistantBody } from "../../styles";
import type { IContentSectionProps } from "./types";

const ContentSection = ({
  walkthroughGuide,
  walkthroughStep,
  walkthroughIndex,
  walkthroughHighlights,
  walkthroughSaving,
  walkthroughSaveFailed,
  walkthroughHandleBack,
  walkthroughHandleAdvance,
  walkthroughHandleSkip,
  walkthroughHandleRestart,
  walkthroughHandleCancel,
  walkthroughCompleted,
  walkthroughHandleDismissCompletion,
  feature,
  featurePending,
  featureFinished,
  onResumeFeature,
  handleSkipScenario,
  handleSelectScenario,
  walkthroughFeatures,
  pendingWalkthroughFeatureIds,
  onDismissWalkthroughFeature,
  submittedQuestion,
  answer,
  questionPending,
  handleAskQuestion,
}: IContentSectionProps) => {
  if (walkthroughGuide && walkthroughStep) {
    return (
      <AssistantBody data-assistant-content>
        <AssistantWalkthroughSection
          title={walkthroughGuide.title}
          step={walkthroughStep}
          index={walkthroughIndex}
          stepCount={walkthroughGuide.steps.length}
          hasHighlight={walkthroughHighlights.length > 0}
          isScenario={Boolean(feature)}
          saving={walkthroughSaving || featurePending}
          saveFailed={walkthroughSaveFailed}
          onBack={walkthroughHandleBack}
          onAdvance={walkthroughHandleAdvance}
          onSkip={walkthroughHandleSkip}
          onRestart={walkthroughHandleRestart}
          onCancel={walkthroughHandleCancel}
          onSkipScenario={handleSkipScenario}
        />
      </AssistantBody>
    );
  }

  if (feature) {
    return (
      <AssistantBody data-assistant-content>
        <AssistantFeatureWalkthrough
          feature={feature}
          pending={featurePending}
          finished={featureFinished}
          onSelect={handleSelectScenario}
          onResume={onResumeFeature}
        />
      </AssistantBody>
    );
  }

  return (
    <AssistantConversationSection
      walkthroughFeatures={walkthroughFeatures}
      pendingWalkthroughFeatureIds={pendingWalkthroughFeatureIds}
      onDismissWalkthroughFeature={onDismissWalkthroughFeature}
      submittedQuestion={submittedQuestion}
      answer={answer}
      pending={questionPending}
      completed={walkthroughCompleted}
      onDismissCompletion={walkthroughHandleDismissCompletion}
      onChoose={handleAskQuestion}
    />
  );
};

export { ContentSection };

export default ContentSection;
